import { ChevronDown, Globe } from "lucide-react";
import { motion } from "framer-motion";
import styles from "./index.module.css";
const HeroComponent = () => {
    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className={styles.container}>
            <div className="absolute inset-0 z-0">
                <svg className="absolute left-0 top-0 h-full w-full" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <circle cx="2" cy="2" r="1" fill="#e0e7ff" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#dots)" />
                </svg>
                <svg className="absolute left-0 bottom-0 h-48 w-full" viewBox="0 0 1440 320" preserveAspectRatio="none">
                    <path
                        fill="#4f46e5"
                        fillOpacity="0.1"
                        d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                    ></path>
                </svg>
            </div>
            <div className="max-w-7xl mx-auto relative z-10">
                <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
                    <svg
                        className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
                        fill="currentColor"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                    >
                        <polygon points="50,0 100,0 50,100 0,100" />
                    </svg>
                    <main className="mt-20 mx-auto max-w-7xl px-4 sm:mt-[6rem] sm:px-6 md:mt-[6rem] lg:mt-24 lg:px-8 xl:mt-28">
                        <div className="sm:text-center lg:text-left">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.2 }}
                                className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 tracking-wide text-indigo-700"
                            >
                                <Globe size={16} className="mr-2" />
                                <span className="text-sm font-semibold">International Workshop</span>
                            </motion.div>
                            <h1 className="mt-4 space-y-4">
                                <span className="block text-4xl sm:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-blue-500">Australia-India Workshop</span>
                                <span className="block text-2xl sm:text-3xl font-medium text-gray-600">Towards Standardisation and Development of</span>
                                <span className="block text-2xl sm:text-3xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
                                    Privacy-Enhancing Cryptographic Techniques
                                </span>
                                <span className="block text-xl sm:text-2xl font-medium text-gray-800">
                                    for Cloud Computing <span className="text-indigo-600 font-semibold">(AICCTP)</span>
                                </span>
                            </h1>
                            <p className="mt-6 text-base text-gray-500 sm:mt-8 sm:text-md max-w-xl">
                                This workshop aims to address various standardization issues regarding privacy and security in cloud computing in Australia and India and tackle these issues via
                                innovative privacy-enhancing cryptographic techniques.
                            </p>
                            <br />
                            <br />
                            <br />
                            <br />
                            {/* <div className="mt-8 sm:mt-10 sm:flex sm:justify-center lg:justify-start space-x-4">
                                
                                <button className="px-8 py-4 rounded-lg bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                                    Register Now
                                </button>
                                <button className="px-8 py-4 rounded-lg text-indigo-700 bg-indigo-50 hover:bg-indigo-100 font-semibold shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                                    Learn More
                                </button>
                            </div> */}
                        </div>
                    </main>
                </div>
            </div>
            <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                <img className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src={require("../../assets/images/showcase9.png")} alt="" />
            </div>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 mb-8">
                <button onClick={() => scrollToSection("speakers")} className="animate-bounce bg-white p-2 w-10 h-10 ring-1 ring-slate-900/5 shadow-lg rounded-full flex items-center justify-center">
                    <ChevronDown className="w-6 h-6 text-indigo-600" />
                </button>
            </div>
        </div>
    );
};

export default HeroComponent;
